// extracted by mini-css-extract-plugin
export default {"button":"ActionsPopup_button__2FbvJ","content":"ActionsPopup_content__987CA","email":"ActionsPopup_email__EfI2D","name":"ActionsPopup_name__BL+LL","user":"ActionsPopup_user__ORenx"};